import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadInviteAFriend),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchInviteAFriendSagas);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { all, put, call, fork, takeEvery, spawn } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { errorActionCreator } from 'redux/saga/helpers';
import { ec, ga } from 'helpers/multitrack';
import { userActionCampaign } from 'redux/saga/entities/bound';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { deepExtract } from 'helpers/deep';
export var LOAD_INVITE_A_FRIEND = 'LOAD_INVITE_A_FRIEND';
export var LOAD_INVITE_A_FRIEND_ERROR = 'LOAD_INVITE_A_FRIEND_ERROR';
export var loadInviteAFriend = function loadInviteAFriend(token) {
  return {
    type: LOAD_INVITE_A_FRIEND,
    token: token
  };
};
export var loadInviteAFriendError = errorActionCreator.bind(null, LOAD_INVITE_A_FRIEND_ERROR);
export function doLoadInviteAFriend(client, _ref) {
  var token, _ref2, _ref3, referral, hasSchedule, variantName, variantId;

  return regeneratorRuntime.wrap(function doLoadInviteAFriend$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          token = _ref.token;
          _context.prev = 1;
          _context.next = 4;
          return all([call(fetchEntityIfNeeded, userActionCampaign, [client, token], {
            key: token
          }), call(writeLocalStorage, 'invite_a_friend--conversion', {
            token: token
          })]);

        case 4:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 1);
          referral = _ref3[0];
          hasSchedule = deepExtract('schedule', referral);

          if (!hasSchedule) {
            _context.next = 13;
            break;
          }

          variantName = deepExtract('variant.variationName', referral, 'Original');
          variantId = deepExtract('variant.variationId', referral);
          _context.next = 13;
          return all([spawn(ec, 'IaF - Landing Page Shown', {
            campaign_id: deepExtract('campaign.campaign_id', referral),
            referral_id: deepExtract('referral_id', referral),
            spots: deepExtract('schedule.availability.status', referral),
            venue_id: deepExtract('schedule.venue.id', referral),
            class_id: deepExtract('schedule.class.id', referral),
            schedule_id: deepExtract('schedule.id', referral),
            promo_code: token,
            variant_name: variantName,
            variant_id: variantId
          }), spawn(ga, 'IAF - Landing page', variantName, "".concat(variantName, " : ").concat(variantId))]);

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](1);
          _context.next = 19;
          return put(loadInviteAFriendError(_context.t0));

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 15]]);
}
export function watchInviteAFriendSagas(client) {
  return regeneratorRuntime.wrap(function watchInviteAFriendSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, LOAD_INVITE_A_FRIEND, doLoadInviteAFriend, client);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}